import script from "./ChurchesSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ChurchesSelector.vue?vue&type=script&setup=true&lang=js"

import "./ChurchesSelector.vue?vue&type=style&index=0&id=e73319d2&lang=scss"

const __exports__ = script;

export default __exports__